import { type ISession, fetchSession } from "@mne-authentication/api";

import type { IEnvConfig } from "@mnemonic/pure-utils/ArgusUtils";

import HttpError from "./Errors/HttpError";

export default async function initializeSession(target: IEnvConfig): Promise<ISession | null> {
  const { domain, apiUrl } = target;
  const query = await fetchSession({ domain }, { apiUrl });

  if (query?.response?.ok) {
    return query.json;
  } else if (query?.response?.status === 401) {
    return null;
  }

  throw new HttpError(query.response.statusText, query);
}
